import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import TpClientInvoiceLineItemService from '../../../../Services/TpClientInvoiceLineItemService';
import TpClientInvoiceLineItemAndJobLineSearchParams from './TpClientInvoiceLineItemAndJobLineSearchParams';
import TpClientInvoiceLineItem from '../../../../Domain/TpClientInvoiceLineItem';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';
import RemoveTpClientInvoiceLineItems from '../../../../Domain/RemoveTpClientInvoiceLineItems';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import TpClientInvoiceStatusEnum from '../../../../Enums/ClientInvoiceStatusEnum';
import { getRemoveQuestion } from '../../../../Helpers/invoiceAutomationStatusHelper';

export default class TpClientInvoiceLineItemAndJobLineSubTab extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpClientInvoiceLineItemAndJobLineSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      allItemsInTheSearchSetAreSelected: false,
      numberOfElementsInTheTable: 0,
      clientId: 0,
      currencyId: 0,
      status: null,
      selectedItem: {},
      invoiceAutomationIsActive: null,
    };
    this.state.searchItem.TpClientInvoiceId = props.tpClientInvoiceId;
    this.state.searchItem.Type = 'all';

    this.refresh = this.refresh.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    TpClientInvoiceLineItem.isHidden = this.isEditButtonHidden.bind(this);
  }

  componentDidMount() {
    TpClientInvoiceService.GetSimpleById(this.props.tpClientInvoiceId)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          this.setState({
            clientId: result.caspianClientId,
            currencyId: result.currencyId,
            status: result.status,
            invoiceAutomationIsActive: result.invoiceAutomationIsActive,
          });
        }
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPCILIAJLST54', error));
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  refresh(reload) {
    if (reload) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
      return;
    }
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  getAllItemsInTheSearchSetAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSearchParameters() {
    return this.state.searchItem;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  isButtonDisabled() {
    return this.state.status !== TpClientInvoiceStatusEnum.Draft;
  }

  isEditButtonHidden() {
    return true;
  }

  getNumberOfSelectedElements() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
  }

  handleExportExcelButtonClick() {
    TpClientInvoiceLineItemService.ExportToExcelWithJobLine(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPCILIAJL95')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  removeFunction() {
    const item = new RemoveTpClientInvoiceLineItems();
    item.TpClientInvoiceId = this.props.tpClientInvoiceId;
    item.LineItemListType = 'LineItem';
    item.RemoveItemIds = this.getSelected().map((item) => item.LineItem);
    item.LineItemSearchItem = this.getSearchParameters();

    if (this.state.numberOfElementsInTheTable > 500 && this.getAllItemsInTheSearchSetAreSelected()) {
      TpClientInvoiceService.RemoveLines(item, this.getAllItemsInTheSearchSetAreSelected()).catch((error) => {
        ErrorMessage.SetErrorMessage('TPCILIAJLST111', error);
      });
      ErrorMessage.SetNotification(
        'Started removing line items from the invoice in the background. You will receive an in-app notification when the process is done.'
      );
      return;
    }

    TpClientInvoiceService.RemoveLines(item, this.getAllItemsInTheSearchSetAreSelected())
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          ErrorMessage.SetLoading(false);
          this.refresh(false);
          return;
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Line Item(s) Removed.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TPCILIAJLST135', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () =>
                ErrorMessage.SetApprove(
                  getRemoveQuestion(
                    `Remove ${this.getNumberOfSelectedElements()} Line Item(s) from their invoice?`,
                    this.state.invoiceAutomationIsActive
                  ),
                  this.removeFunction
                ),
              label: 'Remove Line Items',
              tooltip: 'Remove Line Items',
              roleKey: 'tpclientinvoices_edit',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
          ]}
        />
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpClientInvoiceLineItem}
          serviceFunction={TpClientInvoiceLineItemService.GetListBySearchingWithJobLine}
          convertDBItemsFunction={TpClientInvoiceLineItemService.ConvertDBItems}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='Name'
          shownPanel={this.state.shownPanel}
          searchItem={this.state.searchItem}
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='tpclientinvoices_view'
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          errorCode='TPCILIAJLST177'
        />
      </div>
    );
  }
}
